import { Box } from '@chakra-ui/react'
import { useAtomValue } from 'jotai'
import React, { useCallback, useMemo } from 'react'
import { useSettingsState } from '~/atoms/SettingsState'
import { callListAtom } from '~/atoms/WebphoneState'
import { useCallPopEnabled } from '~/hooks/useCallPopEnabled'
import {
  AnnouncedCall,
  useCallStateAnnouncements,
} from '~/hooks/useCallStateAnnouncements'
import { usePhoneHub } from '~/hooks/usePhone'

import { isPreConnectedStatus } from '@mangovoice/types'

import { IncomingCallModal } from './IncomingCallModal'

const CALL_AUDIO_ELEMENT_ID = 'callAudio'

export const PhoneHub = () => {
  usePhoneHub(CALL_AUDIO_ELEMENT_ID)

  const callList = useAtomValue(callListAtom)
  const {
    settings: {
      webPhone: { doNotDisturbTimestamp },
    },
  } = useSettingsState()
  const doNotDisturb = doNotDisturbTimestamp !== undefined
  const callPopEnabled = useCallPopEnabled()
  const calls = useMemo(() => Array.from(callList.values()), [callList])
  // Matches what the Web Phone shows: desk phone calls only appear (in the
  // call-pop) when call pop is enabled.
  const isCallShown = useCallback(
    (call: AnnouncedCall) =>
      !(doNotDisturb && isPreConnectedStatus(call.status)) &&
      (call.callSource !== 'deskphone' || callPopEnabled),
    [doNotDisturb, callPopEnabled],
  )
  useCallStateAnnouncements(calls, { isCallShown })

  return (
    <Box position="absolute">
      <audio id={CALL_AUDIO_ELEMENT_ID} autoPlay />
      <IncomingCallModal />
    </Box>
  )
}
